import type { ReactNode } from "react"
import { useEffect } from "react"
import { clearAuth, getTokenAvailable } from "./slice"
import { getRefreshToken } from "./refreshTokenStorage"
import { useTokenRefreshMutation } from "@/base/baseApi"
import { useDispatch, useSelector } from "@/base/store"

type Props = {
  children: ReactNode
}

export default function AuthWrapper({ children }: Props) {
  const isTokenAvailable = useSelector(getTokenAvailable)
  const [tokenRefresh] = useTokenRefreshMutation()
  const dispatch = useDispatch()

  // Fetch auth token when missing from store
  useEffect(() => {
    if (isTokenAvailable) {
      // Already have an access token
      return
    }

    const refreshToken = getRefreshToken()
    if (!refreshToken) {
      dispatch(clearAuth())

      return
    }

    void (async () => {
      try {
        await tokenRefresh(refreshToken).unwrap()

        return
      } catch {
        // Invalid refresh token
        dispatch(clearAuth())
      }
    })()
  }, [isTokenAvailable, dispatch, tokenRefresh])

  return children
}
